import type { SocketManager } from './socket-manager';

// Singleton map to manage WebSocket instances
export const sockets: Map<string, SocketManager> = new Map();
